import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'; 
import './menu.css';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';

const Menu = () => {
    const [selectedButton, setSelectedButton] = useState(''); 
    const navigate = useNavigate();

    useEffect(() => {
        const storedButton = localStorage.getItem('selectedButton') || 'billetera'; // Default to 'billetera' if not set
        setSelectedButton(storedButton);
    }, []);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        localStorage.setItem('selectedButton', buttonName); 

        const userRole = localStorage.getItem('role');

        if (buttonName === 'profile') {
            navigate('/profile'); 
        }
        if (buttonName === 'retiros') {
            navigate('/historical_withdraw');
        }
        if (buttonName === 'billetera') {
            if (userRole === 'admin') {
                navigate('/register'); 
            } else {
                navigate('/main'); 
            }
        }
    };

    return ( 
        <footer className="profile-footer">
            <button 
                className={`footer-button ${selectedButton === 'retiros' ? 'selected' : ''}`}
                onClick={() => handleButtonClick('retiros')}
            >
                <RestoreOutlinedIcon 
                    className="footer-icon" 
                    style={{ fontSize: selectedButton === 'retiros' ? '40px' : '40px' }} 
                />
            </button>
            <button 
                className={`footer-button ${selectedButton === 'billetera' ? 'selected' : ''}`}
                onClick={() => handleButtonClick('billetera')}
            >
                <AccountBalanceWalletOutlinedIcon 
                    className="footer-icon" 
                    style={{ fontSize: selectedButton === 'billetera' ? '40px' : '40px' }} 
                />
            </button>
            <button 
                className={`footer-button ${selectedButton === 'profile' ? 'selected' : ''}`}
                onClick={() => handleButtonClick('profile')}
            >
                <PermIdentityIcon 
                    className="footer-icon" 
                    style={{ fontSize: selectedButton === 'profile' ? '40px' : '40px' }} 
                />
            </button>
        </footer>
    );
};

export default Menu;
